import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { DatePipe } from '@angular/common'
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  AuthGuardService,
  CanActivateLogoutViaAuthGuard
} from '../services/auth.service';
import { AdministrationService } from '../services/administration.service';
import { UserService } from '../services/user.service';
import { BillingService } from '../services/billing.service';
import { ReportService } from '../services/report.service';
import { ManagePukalService } from '../services/manage-pukal.service';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { UserListComponent } from './administration/user-list/user-list.component';
import { AccountOfficeStateGovernmentComponent } from './administration/account-office/state-government/state-government.component';
import { BillingFederalGovernmentComponent } from './transaction/billing/federal-government/federal-government.component';

import { AddNewUserDialog } from './administration/user-list/dialog.addnewuser';
import { AddNewAccountOfficeStateGovernmentDialog } from './administration/account-office/state-government/dialog.addnewaccoffice';
import { EditAccountOfficeStateGovernmentDialog } from './administration/account-office/state-government/dialog.editaccoffice';
import { AddNewAccountOfficeOtherGovernmentDialog } from './administration/account-office/other-government/dialog.addnewaccoffice';
import { EditAccountOfficeOtherGovernmentDialog } from './administration/account-office/other-government/dialog.editaccoffice';
import { ViewParentPnrDialog } from './transaction/billing/dialog.viewParentPnr';
import { EditFederalGovernmentTransactionDialog } from './transaction/billing/federal-government/dialog.edittransaction';
import { EditStateGovernmentTransactionDialog } from './transaction/billing/state-government/dialog.edittransaction';
import { EditOtherGovernmentTransactionDialog } from './transaction/billing/other-government/dialog.edittransaction';
import { EditSarawakGovernmentTransactionDialog } from './transaction/billing/swk-government/dialog.edittransaction';
import { ExportFederalGovernmentTransactionDialog } from './transaction/billing/federal-government/dialog.exporttransaction';
import { ExportOtherGovernmentTransactionDialog } from './transaction/billing/other-government/dialog.exporttransaction';
import { ExportStateGovernmentTransactionDialog } from './transaction/billing/state-government/dialog.exporttransaction';
import { ExportSarawakGovernmentTransactionDialog } from './transaction/billing/swk-government/dialog.exporttransaction';
import { TransactionDownloadFileDialog } from './transaction/dialog.downloadFile';
import { AddMissingTransactionDialog } from './transaction/billing/dialog.addmissing';
import { ConfirmLogOutDialog } from './logout/dialog.confirm';
import { ManagePukalLoadingDialog } from './manage-pukal/dialog.loading';
import { ManagePukalDownloadFileDialog } from './manage-pukal/dialog.downloadFile';
import { AddNewAccountFederalGovernmentPukalDialog } from './manage-pukal/ptj-list/federal-government/dialog.addnewaccount';
import { EditAccountFederalGovernmentPukalDialog } from './manage-pukal/ptj-list/federal-government/dialog.editaccount';
import { ExportFTPFederalGovernmentDialog } from './manage-pukal/ptj-list/federal-government/dialog.exporttoftp';
import { AddNewAccountOtherGovernmentPukalDialog } from './manage-pukal/ptj-list/other-government/dialog.addnewaccount';
import { EditAccountPukalOtherGovernmentDialog } from './manage-pukal/ptj-list/other-government/dialog.editaccount';
import { AddNewAccountPukalStateGovernmentDialog } from './manage-pukal/ptj-list/state-government/dialog.addnewaccount';
import { EditAccountPukalStateGovernmentDialog } from './manage-pukal/ptj-list/state-government/dialog.editaccount';
import { ExportFTPStateGovernmentDialog } from './manage-pukal/ptj-list/state-government/dialog.exporttoftp';
import { EditAccountPukalSarawakGovernmentDialog } from './manage-pukal/ptj-list/swk-government/dialog.editaccount';
import { AddNewAccountPukalSarawakGovernmentDialog } from './manage-pukal/ptj-list/swk-government/dialog.addnewaccount';
import { AddNewFareDialog } from './administration/fare-list/dialog.addnewfare';
import { EditFareDialog } from './administration/fare-list/dialog.editfare';
import { AddNewFareTaxDialog } from './administration/fare-tax-obj-id-list/dialog.addnewfaretax';
import { EditFareTaxDialog } from './administration/fare-tax-obj-id-list/dialog.editfaretax';
import { AddNewUserLevelDialog } from './administration/user-level-list/dialog.addnewuserlevel';
import { EditUserLevelDialog } from './administration/user-level-list/dialog.edituserlevel';

import { ReplaceNewLinePipe } from '../shared/pipes/replace-new-line.pipe';
import { BillingStateGovernmentComponent } from './transaction/billing/state-government/state-government.component';
import { LogoutComponent } from './logout/logout.component';
import { BillingOtherGovernmentComponent } from './transaction/billing/other-government/other-government.component';
import { BillingSwkGovernmentComponent } from './transaction/billing/swk-government/swk-government.component';
import { PtjListFederalGovernmentComponent } from './manage-pukal/ptj-list/federal-government/federal-government.component';
import { PtjListStateGovernmentComponent } from './manage-pukal/ptj-list/state-government/state-government.component';
import { PtjListOtherGovernmentComponent } from './manage-pukal/ptj-list/other-government/other-government.component';
import { PtjListSwkGovernmentComponent } from './manage-pukal/ptj-list/swk-government/swk-government.component';
import { CommonReportsFederalGovernmentComponent } from './reports/common-reports/federal-government/federal-government.component';
import { CommonReportsOtherGovernmentComponent } from './reports/common-reports/other-government/other-government.component';
import { CommonReportsStateGovernmentComponent } from './reports/common-reports/state-government/state-government.component';
import { CommonReportsSwkGovernmentComponent } from './reports/common-reports/swk-government/swk-government.component';
import { InvoicesFederalGovernmentComponent } from './reports/invoices/federal-government/federal-government.component';
import { InvoicesOtherGovernmentComponent } from './reports/invoices/other-government/other-government.component';
import { InvoicesStateGovernmentComponent } from './reports/invoices/state-government/state-government.component';
import { InvoicesSwkGovernmentComponent } from './reports/invoices/swk-government/swk-government.component';
import { PukalAccountReportsFederalGovernmentComponent } from './reports/pukal-account-reports/federal-government/federal-government.component';
import { PukalAccountReportsSwkGovernmentComponent } from './reports/pukal-account-reports/swk-government/swk-government.component';
import { AccountOfficeOtherGovernmentComponent } from './administration/account-office/other-government/other-government.component';
import { AccountOfficeSwkGovernmentComponent } from './administration/account-office/swk-government/swk-government.component';
import { FareListComponent } from './administration/fare-list/fare-list.component';
import { FareTaxObjIdListComponent } from './administration/fare-tax-obj-id-list/fare-tax-obj-id-list.component';
import { UserLevelListComponent } from './administration/user-level-list/user-level-list.component';
import { NgxPaginationModule } from 'ngx-pagination';
import {
  SocialLoginModule,
  AuthServiceConfig,
  GoogleLoginProvider
} from "angular-6-social-login";


export function getAuthServiceConfigs() {
  let config = new AuthServiceConfig(
      [
        {
          id: GoogleLoginProvider.PROVIDER_ID,
          provider: new GoogleLoginProvider("890677540611-ga7h6453i2edhau7lb20a13grai6rrbe.apps.googleusercontent.com")
        }
      ]
  );
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    UserListComponent,
    AccountOfficeStateGovernmentComponent,
    BillingFederalGovernmentComponent,
    AddNewFareTaxDialog,
    AddNewUserDialog,
    EditUserLevelDialog,
    AddNewUserLevelDialog,
    AddNewAccountOfficeStateGovernmentDialog,
    EditAccountOfficeStateGovernmentDialog,
    AddNewAccountOfficeOtherGovernmentDialog,
    EditAccountOfficeOtherGovernmentDialog,
    EditFareTaxDialog,
    ViewParentPnrDialog,
    EditFederalGovernmentTransactionDialog,
    EditStateGovernmentTransactionDialog,
    EditOtherGovernmentTransactionDialog,
    EditSarawakGovernmentTransactionDialog,
    ExportFederalGovernmentTransactionDialog,
    ExportOtherGovernmentTransactionDialog,
    ExportStateGovernmentTransactionDialog,
    ExportSarawakGovernmentTransactionDialog,
    TransactionDownloadFileDialog,
    AddMissingTransactionDialog,
    ConfirmLogOutDialog,
    ManagePukalLoadingDialog,
    ManagePukalDownloadFileDialog,
    AddNewAccountFederalGovernmentPukalDialog,
    AddNewAccountOtherGovernmentPukalDialog,
    AddNewAccountPukalSarawakGovernmentDialog,
    EditAccountFederalGovernmentPukalDialog,
    EditAccountPukalOtherGovernmentDialog,
    EditAccountPukalSarawakGovernmentDialog,
    ExportFTPStateGovernmentDialog,
    AddNewAccountPukalStateGovernmentDialog,
    EditAccountPukalStateGovernmentDialog,
    ExportFTPFederalGovernmentDialog,
    AddNewFareDialog,
    EditFareDialog,
    ReplaceNewLinePipe,
    BillingStateGovernmentComponent,
    LogoutComponent,
    BillingOtherGovernmentComponent,
    BillingSwkGovernmentComponent,
    PtjListFederalGovernmentComponent,
    PtjListStateGovernmentComponent,
    PtjListOtherGovernmentComponent,
    PtjListSwkGovernmentComponent,
    CommonReportsFederalGovernmentComponent,
    CommonReportsOtherGovernmentComponent,
    CommonReportsStateGovernmentComponent,
    CommonReportsSwkGovernmentComponent,
    InvoicesFederalGovernmentComponent,
    InvoicesOtherGovernmentComponent,
    InvoicesStateGovernmentComponent,
    InvoicesSwkGovernmentComponent,
    PukalAccountReportsFederalGovernmentComponent,
    PukalAccountReportsSwkGovernmentComponent,
    AccountOfficeOtherGovernmentComponent,
    AccountOfficeSwkGovernmentComponent,
    FareListComponent,
    FareTaxObjIdListComponent,
    UserLevelListComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    BrowserAnimationsModule,
    MaterialModule,
    NgxPaginationModule,
    SocialLoginModule
  ],
  providers: [
    DatePipe,
    UserService,
    AuthGuardService,
    CanActivateLogoutViaAuthGuard,
    AdministrationService,
    BillingService,
    ReportService,
    ManagePukalService,
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    }
  ],
  entryComponents: [
    AddNewFareTaxDialog,
    AddNewUserDialog,
    EditUserLevelDialog,
    AddNewUserLevelDialog,
    AddNewFareDialog,
    EditFareDialog,
    EditFareTaxDialog,
    ViewParentPnrDialog,
    AddNewAccountOfficeStateGovernmentDialog,
    EditAccountOfficeStateGovernmentDialog,
    EditFederalGovernmentTransactionDialog,
    EditStateGovernmentTransactionDialog,
    EditOtherGovernmentTransactionDialog,
    EditSarawakGovernmentTransactionDialog,
    ExportFederalGovernmentTransactionDialog,
    ExportOtherGovernmentTransactionDialog,
    ExportStateGovernmentTransactionDialog,
    ExportSarawakGovernmentTransactionDialog,
    AddNewAccountOfficeOtherGovernmentDialog,
    EditAccountOfficeOtherGovernmentDialog,
    TransactionDownloadFileDialog,
    AddMissingTransactionDialog,
    ConfirmLogOutDialog,
    ManagePukalLoadingDialog,
    ManagePukalDownloadFileDialog,
    AddNewAccountFederalGovernmentPukalDialog,
    AddNewAccountOtherGovernmentPukalDialog,
    EditAccountFederalGovernmentPukalDialog,
    ExportFTPFederalGovernmentDialog,
    EditAccountPukalOtherGovernmentDialog,
    ExportFTPStateGovernmentDialog,
    AddNewAccountPukalStateGovernmentDialog,
    AddNewAccountPukalSarawakGovernmentDialog,
    EditAccountPukalStateGovernmentDialog,
    EditAccountPukalSarawakGovernmentDialog
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
